import dynamic from 'next/dynamic'

export const DynamicCategoriesDrawer = dynamic(
  () => import('.').then((mod) => mod.CategoriesDrawer),
  { ssr: false },
)
